import './index.scss';

import { Modal, ModalFuncProps } from 'antd';

const showPopup = (
  props: ModalFuncProps & { children?; onClose?; iconProps?; id?; className? }
) => {
  const { children, iconProps = {}, className, id, ...rest } = props

  const popup = Modal.confirm({
    width: 'auto',
    title: null,
    footer: null,
    closeIcon: null,
    centered: true,
    maskClosable: true,
    onCancel: () => {
      popup.destroy()
    },

    ...rest,
    className: 'ind-popup-wrap',
    content: (
      <div className='popup-parent'>
        <div
          className='close'
          onClick={() => {
            popup.destroy()
            props.onClose?.()
          }}
        >
          <i {...iconProps} className='iconfont icon-close' />
        </div>
        <div id={className} className={`popup-box ${className}`}>
          {children}
        </div>
      </div>
    )
  })
  return popup
}

export default showPopup
